import { SorterResult } from 'antd/es/table/interface';
import { TablePaginationConfig } from 'antd/lib';
import { useEffect, useState } from 'react';

import { SteeringTableParamsProps } from 'business/steering/hooks/use-get-steering-data-query';
import { SteeringTableFilterData } from 'business/steering/pages/table-page';
import { SteeringDataKeys } from 'business/steering/pages/table-page/components/steering-table/types';
import { SteeringTableContainer } from 'business/steering/pages/table-page/components/steering-table-container';
import { SteeringDataFields } from 'business/steering/pages/table-page/types';
import { useSteeringFilters } from 'business/steering/providers/steering-filters-provider';
import { FilterDataSetter } from 'technical/filter-data';

const defaultCurrentPage = 1;
const defaultPageSize = 50;

const defaultOrderBy = {
  sortOrder: 'descend',
  sortField: SteeringDataKeys.ringNumber,
} as const;

export const SteeringTableWithPagination = ({
  setFilterData,
}: {
  setFilterData: FilterDataSetter<SteeringTableFilterData>;
}) => {
  const filters = useSteeringFilters();

  const [tableParams, setTableParams] = useState<SteeringTableParamsProps>({
    current: defaultCurrentPage,
    pageSize: defaultPageSize,
    ...defaultOrderBy,
  });

  const handleChange = (
    newPagination: TablePaginationConfig,
    _: unknown,
    sorter:
      | SorterResult<SteeringDataFields>
      | SorterResult<SteeringDataFields>[],
  ) => {
    setTableParams({
      current: defaultCurrentPage,
      pageSize: defaultPageSize,
      ...newPagination,
      sortOrder: Array.isArray(sorter)
        ? defaultOrderBy.sortOrder
        : sorter.order,
      sortField: Array.isArray(sorter)
        ? defaultOrderBy.sortField
        : sorter.field,
    });
  };

  // Used to reset pagination on filters change.
  // Table params should be in a provider around filters.
  useEffect(() => {
    setTableParams((params) => ({ ...params, current: defaultCurrentPage }));
  }, [filters]);

  return (
    <SteeringTableContainer
      tableParams={tableParams}
      onChange={handleChange}
      setFilterData={setFilterData}
    />
  );
};
